type ItemContentType = connect.ChatTranscriptItem['ContentType'];

// Shorthand constants for the amazon-connect-chatjs types (from amazon-extended-types.d.ts)
export const ITEM_CONTENT_TYPES: Record<string, ItemContentType> = {
  INTERACTIVE: 'application/vnd.amazonaws.connect.message.interactive',
  JOINED: 'application/vnd.amazonaws.connect.event.participant.joined',
  LEFT: 'application/vnd.amazonaws.connect.event.participant.left',
  ENDED: 'application/vnd.amazonaws.connect.event.chat.ended'
};

export const AUTO_RESPONSE_CONFIGS = [
  {
    incomingTrigger: 'Chat widget initiated',
    automaticResponse: 'Starting chat on behalf of customer'
  }
];
export const INCOMING_TRIGGERS = AUTO_RESPONSE_CONFIGS.map(r => r.incomingTrigger);
export const AUTO_RESPONSES = AUTO_RESPONSE_CONFIGS.map(r => r.automaticResponse);
export const getAutoResponse = (trigger?: string): string => {
  return AUTO_RESPONSE_CONFIGS.find(r => r.incomingTrigger === trigger)?.automaticResponse || '';
};

export const QUEUE_TRIGGER = 'connecting you with someone now';
export const QUEUE_TRIGGER_REGEX = new RegExp(QUEUE_TRIGGER, 'i');

export const CONFIRMATION_TRIGGER = 'do you still need help?';
export const CONFIRMATION_TRIGGER_REGEX = new RegExp(CONFIRMATION_TRIGGER, 'i');
